import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const listInternetForSchool = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: { schoolId: string }) => d)
  .handler(async ({ data, context }) => {
    const { data: rows } = await (context.supabase as any).from("internet_entitlements")
      .select("*, students(full_name,class_label,initials,color_hex)")
      .eq("school_id", data.schoolId).order("created_at", { ascending: false });
    return rows ?? [];
  });

export const listInternetForStudent = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: { studentId: string }) => d)
  .handler(async ({ data, context }) => {
    const [ent, log] = await Promise.all([
      (context.supabase as any).from("internet_entitlements").select("*").eq("student_id", data.studentId).order("created_at", { ascending: false }),
      (context.supabase as any).from("internet_usage_log").select("*, internet_entitlements!inner(student_id)")
        .eq("internet_entitlements.student_id", data.studentId).order("session_start", { ascending: false }).limit(50),
    ]);
    return { entitlements: ent.data ?? [], log: log.data ?? [] };
  });

export const issueInternetBundle = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: { schoolId: string; studentId: string; bundleLabel: string; bundleMb: number; minutes: number; days: number }) => d)
  .handler(async ({ data, context }) => {
    const expires = new Date(Date.now() + data.days * 86400_000).toISOString();
    const { data: ent, error } = await (context.supabase as any).from("internet_entitlements").insert({
      school_id: data.schoolId, student_id: data.studentId,
      bundle_label: data.bundleLabel, bundle_mb: data.bundleMb, minutes_allowed: data.minutes,
      expires_at: expires,
    }).select().single();
    if (error) throw error;
    return { id: ent.id };
  });

export const listRewardsForStudent = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: { studentId: string }) => d)
  .handler(async ({ data, context }) => {
    const { data: rows } = await (context.supabase as any).from("reward_points")
      .select("*").eq("student_id", data.studentId).order("occurred_at", { ascending: false }).limit(100);
    return rows ?? [];
  });

export const awardRewardPoints = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: { schoolId: string; studentId: string; points: number; source: string; reason?: string }) => d)
  .handler(async ({ data, context }) => {
    const { userId } = context;
    const { data: r, error } = await (context.supabase as any).from("reward_points").insert({
      school_id: data.schoolId, student_id: data.studentId, points: data.points,
      source: data.source, reason: data.reason, awarded_by: userId,
    }).select().single();
    if (error) throw error;
    return { id: r.id };
  });
